import { eInvoiceStatusToConfig } from '../../constants/eInvoiceStatusToConfig'
import { EInvoiceStatus } from '../../enums/eInvoiceStatus'
import type { EInvoiceStatusConfig } from '../../types/eInvoiceStatusConfig'

// A null eInvoiceStatus falls back to the Sent config (used as a loading placeholder). A truthy
// eInvoiceStatus that isn't one of the values in eInvoiceStatusToConfig (e.g. a new backend status
// this frontend doesn't know about yet) resolves to undefined — callers must treat that as unknown
// rather than mislabeling it, the same way BillsTableEInvoiceStatusCell does.
export const getEInvoiceStatusConfig = (eInvoiceStatus: EInvoiceStatus | null): EInvoiceStatusConfig | undefined =>
  eInvoiceStatus ? eInvoiceStatusToConfig[eInvoiceStatus] : eInvoiceStatusToConfig[EInvoiceStatus.Sent]
